import { takeLatest } from 'redux-saga/effects';
import { getPublishTerms } from './getPublishTerms';
import { LOAD_PUBLISH_TERMS } from '../../reducers';

export function* publishTermsSagas() {
  yield takeLatest(LOAD_PUBLISH_TERMS, getPublishTerms);
}
